import { Grid, makeStyles, Typography } from "@material-ui/core";
import { useEffect, useMemo, useState } from "react";
import _ from "underscore";
import leftArrowIcon from "../../assets/images/icons/leftArrow.svg";
import rightArrowIcon from "../../assets/images/icons/rightArrow.svg";
import { COLORS } from "../../theme/colors";
import { Icon } from "../base/Icon";

const useStyles = makeStyles((theme) => ({
  arrow: {
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
  },
  item: {
    width: 48,
    height: 48,
    border: `1px solid ${COLORS.darks[0][25]}`,
    borderRadius: 4,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    cursor: "pointer",
    "& > p": {
      fontWeight: "bold",
      color: "#828282",
    },
  },
  activeItem: {
    width: 48,
    height: 48,
    border: `1px solid ${COLORS.darks[0][25]}`,
    backgroundColor: COLORS.purple,
    borderRadius: 4,
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    "& > p": {
      color: COLORS.white,
      fontWeight: "bold",
    },
    cursor: "pointer",
  },
}));

const MAX_PAGES = 5;

export const Pagination = ({ page, root, totalPage, onChange }) => {
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(0);

  useEffect(() => {
    setCurrentPage(page);
  }, [page, currentPage]);

  const pages = useMemo(() => {
    const segment = Math.floor(currentPage / MAX_PAGES);
    let endIndex = segment * MAX_PAGES + MAX_PAGES;
    if (endIndex > totalPage) endIndex = totalPage;
    return _.range(segment * MAX_PAGES, endIndex);
  }, [totalPage, currentPage]);

  const setPage = (page) => {
    setCurrentPage(page);
    onChange(page);
  };

  return (
    <Grid className={root} container alignItems="center">
      {currentPage > 0 && (
        <Icon
          root={classes.arrow}
          hoverable
          src={leftArrowIcon}
          onClick={() => setPage(currentPage - 1)}
        />
      )}
      {pages.map((page, index) => (
        <Grid
          className={page === currentPage ? classes.activeItem : classes.item}
          key={index}
          onClick={() => {
            if (page !== currentPage) {
              setPage(page);
            }
          }}
          container
          justifyContent="center"
          alignItems="center"
        >
          <Typography>{page + 1}</Typography>
        </Grid>
      ))}
      {currentPage < totalPage - 1 && (
        <Icon
          root={classes.arrow}
          hoverable
          src={rightArrowIcon}
          onClick={() => setPage(currentPage + 1)}
        />
      )}
    </Grid>
  );
};
